
import { computed, defineComponent } from 'vue';
import { isWmsRecord } from '@/modules/wms/helpers';

export default defineComponent({
    name: 'wms-source-badge',
    props: {
        record: { type: Object, default: null }
    },
    setup(props) {
        const fromSmart = computed(() => isWmsRecord(props.record));

        return {
            fromSmart
        };
    }
});
